/* globals CriteoDTO */
var jquery = require('jquery');
var HabEvents = require("../../Global/habitaclia-events");

(function () {
    "use strict";

    var Criteo = function (criteoDTO) {
    	this.criteoDTO = criteoDTO;
        __IncludeCriteoTag();
        __RegisterCriteoEvents.call(this);
    };

    var __IncludeCriteoTag = function () {
        /* jshint ignore:start */
        var s = document.createElement("script"),
        el = document.getElementsByTagName("script")[0];
        s.async = true;
        s.defer = true;
        s.src = "//static.criteo.net/js/ld/ld.js";
        el.parentNode.insertBefore(s, el);

        window.criteo_q = window.criteo_q || [];
        /* jshint ignore:end */
    };

    var __RegisterCriteoEvents = function () {
        var self = this;

        jquery.subscribe(HabEvents.EventsEnum.IrAFormularioContacto, function () {
        	window.criteo_q.push(self.criteoDTO.eventViewBasket);
        });

        jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, function () {
        	window.criteo_q.push(self.criteoDTO.eventSolicitudTrackTransaction);
        });

        jquery.subscribe(HabEvents.EventsEnum.FichaLoaded, function () {
        	window.criteo_q.push(self.criteoDTO.eventList);
        });
    };

    Criteo.prototype = {
        constructor: Criteo,
        ficha: function () {
        	window.criteo_q.push(this.criteoDTO.eventList);
        }
    };
    if (window.CriteoDTO) {
        if (typeof module !== 'undefined' && module.exports) {
            module.exports = new Criteo(CriteoDTO);
        }
        else {
            window.Criteo = new Criteo(CriteoDTO);
        }
    } else {
        window.Criteo = Criteo;
    }

}());
